import { createSelector } from "@reduxjs/toolkit";
import { StoreState } from "../../store";

const selector = (state: StoreState) => state.client;

export const clientSelectors = {
  clients: createSelector(selector, (state) => state.clients),
};
